/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Meta_Ogdescription1Inputs */

const ja_contact_meta_ogdescription1 = /** @type {(inputs: Contact_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン（PLAYBRAIN）へのお問い合わせはこちらからお願いいたします。`)
};

const en_contact_meta_ogdescription1 = /** @type {(inputs: Contact_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For inquiries to PLAYBRAIN Inc., please contact us here.`)
};

/**
* | output |
* | --- |
* | "For inquiries to PLAYBRAIN Inc., please contact us here." |
*
* @param {Contact_Meta_Ogdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_meta_ogdescription1 = /** @type {((inputs?: Contact_Meta_Ogdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Meta_Ogdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_meta_ogdescription1(inputs)
	return en_contact_meta_ogdescription1(inputs)
});
export { contact_meta_ogdescription1 as "contact_meta_ogDescription" }